import React from "react";
import { MDBDataTableV5 } from "mdbreact";

const _CheckBox = (props) => {
  return (
    <MDBDataTableV5
      entriesLabel="# de Entradas"
      infoLabel={["Viendo", "al", "de", "entradas"]}
      searchLabel="Buscar" 
      {...props}
      
    />
  );
};
export default _CheckBox;
